import React from 'react'

import { Icon } from 'src/chrome'
import { Icons, IconType } from 'src/chrome/Icon/icons'

import styles from './textBarMobile.module.scss'

interface Props<T extends string> {
  tool?: string
  items: {
    name: T
    icon: IconType | Icons
    viewBox?: string | undefined
    size: number
  }[]
  style?: React.CSSProperties
  onClick?: (controlName: T) => void
}

const TextBarMobile = <T extends string>(props: Props<T>) => {
  const { tool, items, onClick, style } = props
  return (
    <div className={styles.mobileTextBar} style={style}>
      {items.map((item, index) => (
        <div
          key={index}
          className={styles.item}
          onClick={() => onClick?.(item.name)}
        >
          <Icon
            icon={item.icon}
            viewBox={item.viewBox}
            size={item.size}
            color={tool === item.name ? '#E841B3' : '#6f8394'}
          />
        </div>
      ))}
    </div>
  )
}

export default TextBarMobile
